import React, { useEffect, useState } from 'react'
import { NavBar } from 'components/NavBar/NavBar'
import { PageWrapper, H1WithBack, Flex, ContentWrapper } from 'styling/GlobalStyles'
import { TaskOperationTab } from './TaskTOperationTab'
import { TasksTabs, TasksTabsContainer } from './DragComponents/Tasks.styled'
import { useDispatch, useSelector } from 'react-redux'
import { addTaskTemplate } from 'features/taskTemplates/taskTemplatesSlice'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { AppDispatch, RootState } from 'store'
import { TaskComponentsTab } from './TaskComponentsTab'
import { ITaskTemplateState } from 'types/task-templates.interface'
import { taskTemplatesInitialState } from './taskData'
import { TaskTDesignTab } from './TaskTDesignTab'

export const AddTaskTemplate = () => {
  const [active, setActive] = useState('Operation')
  const [state, setState] = useState<ITaskTemplateState>(taskTemplatesInitialState)

  const { createdId } = useSelector((store: RootState) => store.taskTemplates)
  const navigate = useNavigate()
  const dispatch = useDispatch<AppDispatch>()

  const handleSubmit = async () => {
    if (!state.operationTypeId) {
      toast.warn('Task capability must be selected.')
      return
    }
    if (state.components.some((c) => !c.componentType)) {
      toast.warn('Components must have set component type.')
      return
    }
    if (state.operationTypeParameterValues.some((t) => !t.minimumValue || (t.parameterId == 1 && !t.desiredValue))) {
      toast.warn('Capabilities must have set value.')
      return
    }
    if (state.toolTypeComponents.some((t) => !t.name)) {
      toast.warn('Tool type components must have set name.')
      return
    }


    await dispatch(addTaskTemplate(state))
  }

  useEffect(() => {
    if (createdId) {
      navigate('/task-templates/' + createdId + '/edit/logic')
    }
  }, [createdId])

  const renderTabs = () => {
    switch (active) {
      case 'Operation':
        return <TaskOperationTab state={state} setState={setState} handleSubmit={handleSubmit} />
      case 'Design':
        return <TaskTDesignTab state={state} setState={setState} handleSubmit={handleSubmit} />
      case 'Components':
        return <TaskComponentsTab state={state} setState={setState} handleSubmit={handleSubmit} />
      default:
        return <TaskOperationTab state={state} setState={setState} handleSubmit={handleSubmit} />
    }
  }
  return (
    <div>
      <NavBar />
      <PageWrapper noFooter>
        <Flex between center mb='16'>
          <H1WithBack arrow title='Add Task' />
          <TasksTabsContainer>
            <TasksTabs active={active === 'Operation'} onClick={() => setActive('Operation')}>
              Operation
            </TasksTabs>
            <TasksTabs active={active === 'Design'} onClick={() => setActive('Design')}>
              Design
            </TasksTabs>
            <TasksTabs active={active === 'Components'} onClick={() => setActive('Components')}>
              Components
            </TasksTabs>
          </TasksTabsContainer>
        </Flex>
        <ContentWrapper>{renderTabs()}</ContentWrapper>
      </PageWrapper>
    </div>
  )
}
